<template>
  <aside class="hidden sm:flex border-r relative flex-col justify-around print:hidden bg-white" style="width: 250px">
    <router-link
      to="/"
      class="bg-white flex flex-col justify-around border border-t-0 overflow-hidden"
      style="height: 122px; width: 250px"
    >
      <Logo id="fabricator_logo" :src="styleStore.fabricator_logo" :customer-name="customerStore.customer_name" />
    </router-link>

    <div class="overflow-y-auto overflow-x-hidden shrink-0 grow h-px">
      <BusinessMenuItems :initial-setup />
    </div>

    <div class="mb-4">
      <div class="text-center">
        <TouchBranding />
      </div>
    </div>
  </aside>
</template>

<script>
import { mapStores } from 'pinia'
import { useStyleStore } from '@/pinia/style'
import { useCustomerStore } from '@/pinia/customer'
import BusinessMenuItems from '@/components/shared/nav/BusinessMenuItems.vue'
import Logo from '@/components/shared/nav/Logo.vue'
import TouchBranding from '@/components/shared/ui/TouchBranding.vue'

export default {
  name: 'BusinessSidebarMenu',
  components: {
    BusinessMenuItems,
    Logo,
    TouchBranding
  },
  props: {
    initialSetup: Boolean
  },
  computed: {
    ...mapStores(useStyleStore, useCustomerStore)
  }
}
</script>
